import { h, Fragment } from 'preact';
import { useState, useMemo } from "preact/hooks";
import Plus from 'utils/icon/plus.svg';
import Minus from 'utils/icon/minus.svg';

const BlogFiltersFacets = (
  {
    items,
    values,
    facets,
    onFilter,
    sortValues,
    sortBy,
    onClose,
    inline = false,
    articleCounter,
    setArticleCounter
  }
) => {
  const [sort, setSort] = useState(sortBy);
  const [tags, setTags] = useState(values);
  const [isTagsOpen, setIsTagsOpen] = useState(true);
  const [isSortOpen, setIsSortOpen] = useState(true);

  const submitLabel = useMemo(() => {
    const posts = new Set(tags.reduce((a, b) => {
      const facet = facets.find(i => i.tag === b);
      if (facet) {
        return [...a, ...facet.ids]
      }
      return a;
    }, []));
    return window.TMW.Strings.filters.viewResults.replace('{{ count }}', posts.size > 0 ? `<span>${posts.size}</span>` : '');
  }, [tags]);

  const updateArticleCount = (method, count) => {

    if (method === "add" && articleCounter.displayTotalArticleCount) {
      setArticleCounter({
        ...articleCounter,
        displayTotalArticleCount: false,
        count
      })

      return;
    }

    let articleCount;

    if (method === "add") {
      articleCount = articleCounter.count + count;

      setArticleCounter({
        ...articleCounter,
        count: articleCount
      })
    }
    else {
      articleCount = articleCounter.count - count;

      setArticleCounter({
        ...articleCounter,
        count: articleCount
      })
    }
  }

  const handleChange = (e) => {
    if (e.target.checked) {
      if (inline) {
        onFilter({
          tags: [...values, e.target.value]
        });
      } else {
        setTags((state) => [...state, e.target.value]);
      }

      updateArticleCount("add", parseInt(e.target.dataset.facetCount, 10));
    } else {
      if (inline) {
        onFilter({
          tags: values.filter(i => i !== e.target.value)
        });
      } else {
        setTags((state) => [...state.filter(i => i !== e.target.value)]);
      }

      updateArticleCount("minus", parseInt(e.target.dataset.facetCount, 10));
    }
  }

  const handleSubmit = () => {
    onFilter({
      tags,
      sort
    });
    onClose();
  }

  const handleClear = () => {
    onFilter({
      tags: []
    });

    setArticleCounter({
      ...articleCounter,
      displayTotalArticleCount: true,
      count: articleCounter.totalArticleCount
    })

    onClose();
  }

  return (
    <>
      <div className={!inline ? 'divide-y divide-grey-4 border-t  border-grey-4 flex-1 min-h-0 overflow-y-auto' : ''}>
        {!inline && (
          <div
            className="py-[25px] px-5 lg:pr-2.5 lg:pl-0"
          >
            <button
              onClick={() => setIsSortOpen((value) => !value)}
              className="w-full flex items-center justify-between text-black"
            >
            <span className="text-headline-tag">
              {window.TMW.Strings.filters.sortBy}:
              <span className="pl-1">{window.TMW.Strings.blog.sort[sort.id]}</span>
            </span>
              {isSortOpen ? <Minus/> : <Plus/>}
            </button>
            <ul
              className={`pt-[25px] space-y-[23px] lg:pl-5 ${isSortOpen ? '' : 'hidden'}`}
            >
              {Object.keys(sortValues).map((key) => (
                <li key={sortValues[key].id}>
                  <label className="custom-radio">
                  <span className="[&>*]:text-body-2 [^>*]:text-black">
                      {window.TMW.Strings.blog.sort[key]}
                  </span>
                    <input
                      className="custom-radio-input text-black"
                      onChange={(e) => setSort(e.target.value)}
                      type="radio"
                      name="sort"
                      value={key}
                      checked={sort === key}
                    />
                    <span className="custom-radio-checkmark border-none"></span>
                  </label>
                </li>
              ))}
            </ul>
          </div>
        )}
        {!!items?.length && (
          <div
            className="py-[25px] px-5 lg:pr-2.5 lg:pl-0"
          >
            <button
              disabled={inline}
              onClick={() => setIsTagsOpen((value) => !value)}
              className="w-full flex items-center justify-between text-black"
            >
              <span className="text-headline-tag">{window.TMW.Strings.blog.tags}</span>
              {!inline && (
                <>
                  {isTagsOpen ? <Minus/> : <Plus/>}
                </>
              )}
            </button>
            <ul
              className={`pt-[25px] space-y-[23px] lg:pl-5 ${isTagsOpen ? '' : 'hidden'}`}
            >
              {items.map((item, index) => (
                <li key={item}>
                  <label className="custom-checkbox">
                <span className="[&>*]:text-body-2 [^>*]:text-black">
                  <span>{item}</span>
                  {facets[index]?.amount > 0 && (
                    <span className="pl-1">{`(${facets[index].amount})`}</span>
                  )}
                </span>
                    <input
                      className="custom-checkbox-input"
                      onChange={handleChange}
                      type="checkbox"
                      value={item}
                      checked={
                        inline ? values.includes(item) : tags.includes(item)
                      }
                      data-facet-count={facets[index]?.amount}
                    />
                    <span className="custom-checkbox-checkmark"></span>
                  </label>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      {!inline && (
        <div className='border-t border-black mt-[17px] p-5 flex items-center justify-between gap-x-2.5'>
          <button
            className='button button--secondary h-[61px]'
            type='button'
            onClick={handleClear}
          >
            {window.TMW.Strings.filters.clear}
          </button>
          <button
            className='button button--primary gap-x-1'
            type='button'
            onClick={handleSubmit}
            dangerouslySetInnerHTML={{ __html: submitLabel }}
          ></button>
        </div>
      )}
    </>
  )
};

export default BlogFiltersFacets;
